<div class="PGStripeConnect {{small ? 'PGStripeConnect--Small' : ''}}">
    @if (isLoading) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    <button type="button" class="stripe-connect" (click)="doConnect()" [attr.aria-label]="'pg-stripe-connect.a11y.connect' | locTranslate">
        <span>Connect with</span>
    </button>
</div>
<!--<a class="stripe-connect slate"><span>Connect with</span></a>-->
